module.exports = "images/franceinfo.7d83db02.png";